export default "__VITE_ASSET__CgzxOtbb__"